module.exports = __webpack_public_path__ + "static/img/icon_teacher.f786f4f9.png";